import React from "react";
import { Row, Col } from "react-bootstrap";

function WorkExperience() {
  return (
    <section className="experience-section">
      <h1 className="project-heading mb-5">
        My <strong className="purple">Work Experience</strong>
      </h1>

      <Row className="g-4">
        {/* ====================================================== */}
        {/* Telkomsel */}
        {/* ====================================================== */}

        <Col lg={6} md={6}>
          <div className="experience-card h-100">
            <div className="experience-header">
              <div className="experience-title">
                <h3>Software Engineer (MSIB Intern)</h3>
                <h5>PT Telekomunikasi Seluler (Telkomsel)</h5>
              </div>

              <div className="experience-date">
                <span>📍 Medan, Indonesia</span>
                <span>Sep 2024 – Dec 2024</span>
              </div>
            </div>

            <ul>
              <li>
                Designed and developed an enterprise-level sales dashboard and
                business analytics platform that transformed large-scale sales
                data into interactive visualizations, improving data
                accessibility and supporting faster, data-driven business
                decisions.
              </li>

              <li>
                Optimized PostgreSQL database structures handling more than{" "}
                <strong className="purple">150,000 sales records</strong>,
                resulting in approximately{" "}
                <strong className="purple">15% faster</strong> query performance
                and significantly improving reporting efficiency.
              </li>

              <li>
                Developed ETL processes and automated sales data comparison
                tools that reduced upload time by approximately{" "}
                <strong className="purple">20%</strong> and accelerated
                analytical workflows by up to{" "}
                <strong className="purple">45%</strong>.
              </li>

              <li>
                Worked within an Agile development environment, collaborating
                with mentors and engineers using Git-based workflows while
                implementing scalable web solutions following modern software
                engineering best practices.
              </li>
            </ul>

            <div className="tech-stack">
              <span>CodeIgniter</span>
              <span>PHP</span>
              <span>JavaScript</span>
              <span>PostgreSQL</span>
              <span>Tailwind CSS</span>
              <span>Git</span>
            </div>
          </div>
        </Col>

        {/* ====================================================== */}
        {/* PTPN */}
        {/* ====================================================== */}

        <Col lg={6} md={6}>
          <div className="experience-card h-100">
            <div className="experience-header">
              <div className="experience-title">
                <h3>IT Support (Intern)</h3>
                <h5>PT Perkebunan Nusantara IV Regional II</h5>
              </div>

              <div className="experience-date">
                <span>📍 Medan, Indonesia</span>
                <span>Feb 2025 – Apr 2025</span>
              </div>
            </div>

            <ul>
              <li>
                Delivered technical support for more than{" "}
                <strong className="purple">50 organizational devices</strong>,
                including hardware deployment, troubleshooting, software
                installation, preventive maintenance, and workstation
                configuration to ensure uninterrupted daily operations.
              </li>

              <li>
                Installed and maintained office technology infrastructure,
                including computers, printers, scanners, Microsoft Office
                applications, operating systems, and LAN connectivity across
                multiple departments.
              </li>

              <li>
                Diagnosed and resolved hardware failures, software issues,
                peripheral integration, and network connectivity problems,
                minimizing downtime while improving employee productivity and
                operational reliability.
              </li>

              <li>
                Assisted the IT team with infrastructure upgrades, PC assembly,
                device replacement, meeting support, and routine maintenance
                activities to maintain a secure and efficient working
                environment.
              </li>
            </ul>

            <div className="tech-stack">
              <span>Operating System</span>
              <span>Networking</span>
              <span>Microsoft Office</span>
              <span>Hardware</span>
              <span>Troubleshooting</span>
            </div>
          </div>
        </Col>

        {/* ====================================================== */}
        {/* Research */}
        {/* ====================================================== */}

        <Col lg={6} md={6}>
          <div className="experience-card h-100">
            <div className="experience-header">
              <div className="experience-title">
                <h3>Research and Teaching Assistant (Part-time)</h3>
                <h5>Computer Science Faculty</h5>
              </div>

              <div className="experience-date">
                <span>📍 Medan, Indonesia</span>
                <span>Oct 2025 – May 2026</span>
              </div>
            </div>

            <ul>
              <li>
                Collaborated with lecturers in multidisciplinary research and
                community service projects by designing technology-driven
                solutions involving{" "}
                <strong className="purple">Internet of Things (IoT)</strong>,{" "}
                <strong className="purple">Machine Learning</strong>, and{" "}
                <strong className="purple">Computer Vision</strong> to address
                real-world challenges in agriculture and digital innovation.
              </li>

              <li>
                Developed smart monitoring systems capable of collecting and
                visualizing real-time environmental data, including temperature,
                humidity, soil moisture, nutrient levels, and plant conditions
                using embedded devices and cloud-based technologies.
              </li>

              <li>
                Conducted image processing and machine learning experiments for
                pest detection, object classification, feature extraction, and
                performance evaluation while supporting research publications
                and academic documentation.
              </li>

              <li>
                Worked collaboratively with lecturers and fellow researchers
                through the entire research lifecycle, including requirement
                analysis, software development, system testing, documentation,
                and result presentation.
              </li>
            </ul>

            <div className="tech-stack">
              <span>Arduino</span>
              <span>ESP32</span>
              <span>Python</span>
              <span>OpenCV</span>
              <span>Firebase</span>
              <span>C++</span>
              <span>JavaScript</span>
              <span>Git</span>
            </div>
          </div>
        </Col>

        {/* ====================================================== */}
        {/* BKPSDM */}
        {/* ====================================================== */}

        <Col lg={6} md={6}>
          <div className="experience-card h-100">
            <div className="experience-header">
              <div className="experience-title">
                <h3>Programmer (Intern)</h3>
                <h5>BKPSDM Kota Binjai</h5>
              </div>

              <div className="experience-date">
                <span>📍 Binjai, Indonesia</span>
                <span>Feb 2026 – May 2026</span>
              </div>
            </div>

            <ul>
              <li>
                Contributed to the development and enhancement of the BKPSDM
                employee management information system by improving application
                performance, refining user interfaces, and implementing new
                functionalities to streamline administrative workflows.
              </li>

              <li>
                Designed and developed the{" "}
                <strong className="purple">PLT (Acting Position)</strong> module
                within the SIMPEG application, enabling automated TPP
                calculations based on government regulations and reducing manual
                administrative processes.
              </li>

              <li>
                Processed, validated, and maintained employee datasets to
                generate reliable reports, improve data consistency, and support
                accurate decision-making across multiple government departments.
              </li>

              <li>
                Collaborated directly with stakeholders to analyze business
                requirements, resolve system issues, and continuously improve
                application reliability, usability, and operational efficiency.
              </li>
            </ul>

            <div className="tech-stack">
              <span>CodeIgniter 4</span>
              <span>PHP</span>
              <span>JavaScript</span>
              <span>MySQL</span>
              <span>Bootstrap</span>
              <span>Git</span>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
}

export default WorkExperience;
